import type { MenuMixedOption } from "naive-ui/es/menu/src/interface"
import type { ComposerTranslation } from "vue-i18n"
import type { I18nString } from "@/lang/config"
import { h } from "vue"
import { RouterLink } from "vue-router"
import { ICONS } from "@/const"
import { UserRole } from "@/types/auth"
import { renderIcon } from "@/utils"

export default function getItems(args: {
	userRole?: UserRole
	mode: "vertical" | "horizontal"
	collapsed: boolean
	t: ComposerTranslation
}): MenuMixedOption[] {
	switch (args.userRole) {
		case UserRole.DOCTOR:
			return [
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Dashboard"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.dashboard`) }
						),
					key: "Dashboard",
					icon: renderIcon(ICONS.pages.dashboard)
				},
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "PatientsList"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.patients`) }
						),
					key: "Patients",
					icon: renderIcon(ICONS.pages.patients)
				},
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Calendar"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.calendar`) }
						),
					key: "Calendar",
					icon: renderIcon(ICONS.pages.calendar)
				},
				/* TODO-NEXT: MVP2 attivare link a chat
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Chat"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.chat`) }
						),
					key: "Chat",
					icon: renderIcon(ICONS.pages.chat)
				},
				*/
				{
					key: "divider-1",
					type: "divider"
				},
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Tools.PregnancyCalculator"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.pregnancy_wheel`) }
						),
					key: "Tools.PregnancyCalculator",
					icon: renderIcon(ICONS.tools.pregnancy_calculator)
				},
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Tools.Monitoring"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.monitoring`) }
						),
					key: "Tools.Monitoring",
					icon: renderIcon(ICONS.tools.monitoring)
				},
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Tools.Biometry"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.fetal_biometry`) }
						),
					key: "Tools.Biometry",
					icon: renderIcon(ICONS.tools.biometry)
				}
				/* TODO-NEXT: MVP2 attivare link a doppler
				{
					label: () =>
						h(
							RouterLink,
							{
								to: {
									name: "Tools.Doppler"
								}
							},
							{ default: () => args.t<I18nString>(`navigation.menu.doppler`) }
						),
					key: "Tools.Doppler",
					icon: renderIcon(ICONS.tools.doppler)
				}
				*/
			]
		default:
			return []
	}
}
